const getBucketListActionElement = (feature) => {
    const bucketList = document.getElementById('bucket-list');
    let linkClass = "poi-card-add-bucketlist";
    let linkText = "Ajouter à ma bucket list";

    if (bucketList) {
        const item = bucketList.querySelector('[data-bucket-id="' + feature.post_id + '"]');

        if (item) {
            linkClass = "poi-card-remove-bucketlist";
            linkText = "Retirer de ma bucket list";
        }

        return `
            <a href="javascript:void(0)"
               class="${linkClass}"
               data-title="${feature.title}"
               data-thumbnail="${feature.thumbnail}"
               data-category="${feature.main_category}"
               data-state="${feature.state}"
               data-id="${feature.post_id}"
               data-grade="${feature.grade}"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
                    <g transform="translate(-745 -471)">
                        <g transform="translate(745 471)" fill="#fff" stroke="#011940" stroke-width="1">
                            <circle cx="23" cy="23" r="23" stroke="none"></circle>
                            <circle cx="23" cy="23" r="22.5" fill="none"></circle>
                        </g>
                        <g transform="translate(759.545 484)">
                            <g>
                                <path d="M15.22,0H1.691A1.693,1.693,0,0,0,0,1.691V18.308a1.691,1.691,0,0,0,2.588,1.434l5.739-3.587a.25.25,0,0,1,.258,0l5.74,3.588a1.691,1.691,0,0,0,2.588-1.434V1.691A1.693,1.693,0,0,0,15.22,0ZM12.512,7.276,10.8,8.644a.452.452,0,0,0-.15.482l.783,2.612a.451.451,0,0,1-.7.491l-2.006-1.5a.451.451,0,0,0-.542,0l-2.006,1.5a.451.451,0,0,1-.7-.491l.784-2.612a.451.451,0,0,0-.15-.482L4.4,7.276a.451.451,0,0,1,.282-.8H6.64A.451.451,0,0,0,7.055,6.2l.986-2.3a.451.451,0,0,1,.829,0l.986,2.3a.451.451,0,0,0,.415.274H12.23a.451.451,0,0,1,.282.8Z" transform="translate(0)" fill="#011940"></path>
                            </g>
                        </g>
                        <g transform="translate(673 189)">
                            <circle cx="7" cy="7" r="7" transform="translate(104 282)" fill="#fff"></circle>
                            <g transform="translate(104 282)">
                                <g>
                                    <path d="M7,0a7,7,0,1,0,7,7A7.014,7.014,0,0,0,7,0M9.692,8.077H8.077V9.563a1.077,1.077,0,0,1-2.154,0V8.077H4.308a1.077,1.077,0,0,1,0-2.154H5.923V4.308a1.077,1.077,0,0,1,2.154,0V5.923H9.692a1.077,1.077,0,0,1,0,2.154" fill="#011940"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
                <span>${linkText}</span>
            </a>
        `;
    }

    return ``;
}

const getPoiBookButtonTemplate = (affiliation) => {
    if (affiliation) {
        return `
            <a href="${affiliation}" target="_blank" class="poi-card-book">
                <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
                  <g transform="translate(-821 -471)">
                    <g transform="translate(821 471)" fill="#15ac72" stroke="#15ac72" stroke-width="1">
                      <circle cx="23" cy="23" r="23" stroke="none"/>
                      <circle cx="23" cy="23" r="22.5" fill="none"/>
                    </g>
                    <g transform="translate(832.504 484.468)">
                      <g transform="translate(-0.169 -0.468)">
                        <path d="M183.028,360A2.029,2.029,0,1,1,181,362.027,2.029,2.029,0,0,1,183.028,360" transform="translate(-172.804 -343.67)" fill="#fff"/>
                        <path d="M334.027,360A2.029,2.029,0,1,1,332,362.027,2.029,2.029,0,0,1,334.027,360" transform="translate(-316.995 -343.67)" fill="#fff"/>
                        <path d="M.676,1.352H3.5L6.761,12.781l-.256.512A2.029,2.029,0,0,0,8.32,16.229H19.7a.676.676,0,0,0,0-1.352H8.32a.676.676,0,0,1-.6-.979l.187-.374H19.7a.677.677,0,0,0,.65-.491l2.7-9.467a.676.676,0,0,0-.65-.862H5.289L4.657.49A.677.677,0,0,0,4.006,0H.676a.676.676,0,0,0,0,1.353Z" transform="translate(0.035 0.099)" fill="#fff"/>
                      </g>
                    </g>
                  </g>
                </svg>
                <span>Réserver</span>
            </a>
        `;
    }

    return '';
}

const displayPoiStateAndCity = (city, state) => {
    return city
        ? city + ', ' + state
        : state;
}

const getPoiUrl = (id, mainCategory, title) => {
    if (mainCategory === 'city') {
        return '/ville/' + slugify(title);
    } else if (mainCategory === 'state') {
        return '/etat/' + slugify(title);
    } else if (mainCategory === 'park') {
        return '/parc/' + slugify(title);
    } else {
        return '/planifier/poi/' + id;
    }
}

window.getPoiPopup = (feature, coords) => {
    return `
        <div class="poi-popup">
            <a class="poi-card-title" target="_blank" href="${getPoiUrl(feature.post_id, feature.main_category, feature.title)}/">
                <div class="img-container" style="${feature.thumbnail ? 'background-image: url(' + feature.thumbnail + ')' : ''}">
                    <div class="flag-container">
                        ${getSvgFlag(feature.main_category)}
                        <div class="flag-content">
                            ${getCategoryIcon(feature.main_category)}
                            <span>${feature.grade ?? ''}</span>
                        </div>
                    </div>
                </div>
                <div class="title-container">
                    <span class="poi-title">${feature.title}</span>
                    <span class="poi-state">${displayPoiStateAndCity(feature.city, feature.state)}</span>
                    <span class="poi-show">› Voir la fiche</span>
                </div>
            </a>
            <div class="button-container">
                <a href="javascript:void(0)" class="poi-card-add-roadtrip" data-title="${feature.title}" data-position="${coords}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="47" height="46" viewBox="0 0 47 46">
                        <g transform="translate(-669 -471)">
                            <g transform="translate(669 471)" fill="#fff" stroke="#c84c47" stroke-width="1">
                                <circle cx="23" cy="23" r="23" stroke="none"></circle>
                                <circle cx="23" cy="23" r="22.5" fill="none"></circle>
                            </g>
                            <g transform="translate(681.265 484)">
                                <g>
                                    <path d="M18.5,18.14a1.86,1.86,0,1,1-1.86-1.86,1.862,1.862,0,0,1,1.86,1.86M4.961,16.28a1.86,1.86,0,1,0,1.86,1.86,1.862,1.862,0,0,0-1.86-1.86m16.507-3.558v3.7a2.358,2.358,0,0,1-1.9,2.294,2.989,2.989,0,1,0-5.921-.574,3.01,3.01,0,0,0,.081.669l-5.863.011a2.989,2.989,0,1,0-5.82-.032A2.44,2.44,0,0,1,.564,18.1,2.058,2.058,0,0,1,0,16.663L.01,14.425A3.01,3.01,0,0,1,2.66,11.8h.587L6.074,8.5A4.657,4.657,0,0,1,8.6,7.121V6.414H7.486a.764.764,0,1,1,0-1.528h.7V2.807a.763.763,0,0,1,.764-.764h3.985V.764A.763.763,0,0,1,13.7,0h3.714a.763.763,0,0,1,.764.764V4.887h.5a.764.764,0,0,1,0,1.528H17.169v.67a3.575,3.575,0,0,1,2.569,1.8l1.524,3.079A1.448,1.448,0,0,1,21.469,12.722ZM10.13,7.053h5.51V6.414H10.13Zm.472,6.611a.763.763,0,0,0-.764-.764H8.179a.764.764,0,1,0,0,1.528H9.838a.764.764,0,0,0,.764-.764m.96-5.083H9.236a3.162,3.162,0,0,0-2,.92L5.26,11.8h6.3Zm7.913,3.213L18.368,9.558a2.013,2.013,0,0,0-1.573-.976H13.089v3.214Z" transform="translate(0)" fill="#c84c47"></path>
                                </g>
                            </g>
                            <g transform="translate(598 189)">
                                <circle cx="7" cy="7" r="7" transform="translate(104 282)" fill="#fff"></circle>
                                <g transform="translate(104 282)">
                                    <g clip-path="url(#clip-path-2)">
                                        <path d="M7,0a7,7,0,1,0,7,7A7.014,7.014,0,0,0,7,0M9.692,8.077H8.077V9.563a1.077,1.077,0,0,1-2.154,0V8.077H4.308a1.077,1.077,0,0,1,0-2.154H5.923V4.308a1.077,1.077,0,0,1,2.154,0V5.923H9.692a1.077,1.077,0,0,1,0,2.154" fill="#c84c47"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <span>Ajouter au roadtrip</span>
                </a>
                ${getBucketListActionElement(feature)}
                ${getPoiBookButtonTemplate(feature.affiliation)}
            </div>
        </div>
    `;
}